import {Component} from "@angular/core";
import {
  IT_VIEW_SUB_TITLE_CONTROLLER,
  IViewSubTitleController,
  MK_VIEW_SUB_TITLE
} from "../_controllers/IViewSubTitleController";
import {ViewSubTitleModel} from "../_models/ViewSubTitleModel";
import {ViewSubTitleController} from "../_controllers/view-sub-title.controller";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-view-sub-title',
  templateUrl: './view-sub-title.view.html',
  styleUrls: ['./view-sub-title.view.scss'],
  providers: [
    {provide: IT_VIEW_SUB_TITLE_CONTROLLER, useClass: ViewSubTitleController},
  ]
})
export class ViewSubTitleView extends AbstractView<IViewSubTitleController> {

  protected model: ViewSubTitleModel;

  constructor() {
    super(IT_VIEW_SUB_TITLE_CONTROLLER);

    this.model = this.getController().getModel(MK_VIEW_SUB_TITLE);
  }
}
